<div class="color">
    <div class="container">
        <div class="text">
            <h1>Lean leadership</h1>
            <p>
                The theory behind Lean is not hard to understand. Many companies
                struggle when they try to go from theory and talking – to
                implement Lean in practice. In 80% of change programs within
                industry, companies fail to reach sustainable over a long time –
                1 to 3 years after program is completed. Why is that? You will
                find the answer in management and leader behaviour and the
                understanding of different roles in the company on different
                levels to be able to continue to drive continuous improvement.
                To understand your role as a leader and be able to drive and
                support improvements in praxis – to “walk the walk” – is the key
                to sustainable improvements over time. Our way of doing this is
                the Train the Trainer approach. The leader will be a trainer of
                people in his own area of responsibility. The most critical role
                for a leader is the leader closest to the values stream. That is
                why we focus hardest on training the leaders closest to value
                stream.
            </p>
            <div class="bullet">
                <div>
                    <p>
                        <strong
                            >A Lean system for leaders is built by 4 building
                            blocks:</strong
                        >
                    </p>
                    <ul>
                        <li>Standardized work for leaders</li>
                        <li>Visual controls</li>
                        <li>Daily follow up process</li>
                        <li>Discipline</li>
                    </ul>
                </div>
                <div>
                    <p>
                        <strong
                            >We will train leaders on different levels:</strong
                        >
                    </p>
                    <ul>
                        <li>
                            The baseline for Lean Leadership – Go see, Ask
                            questions, Show respect
                        </li>
                        <li>
                            One to one coaching – strength and improvement areas
                            are discussed
                        </li>
                        <li>
                            On the job Training – practical training of what we
                            have learnt
                        </li>
                        <li>
                            Gemba walks- we identify waste and improvement areas
                            and agree upon actions
                        </li>
                    </ul>
                </div>
            </div>
            <img src="pyramid-ledare.png" alt="pyramid" />
        </div>
    </div>
</div>

<style>
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 100px;
        padding-bottom: 300px;
        max-width: 800px;
    }

    @media screen and (max-width: 900px) {
        .bullet {
            flex-direction: column;
        }
        .container {
            padding-bottom: 100px !important;
        }
        h1 {
            font-size: 3em !important;
        }
    }
    .color {
        background-color: whitesmoke;
    }
    h1 {
        font-size: 4em;
    }
    .bullet {
        display: flex;
        gap: 50px;
    }

    img {
        padding-top: 50px;
        image-rendering: -webkit-optimize-contrast;
        width: 100%;
    }
</style>
